// @ts-check

/** @type import("../../../types/images").Image */
export default {
  emarsys: {
    aliases: ["b2clogo-simple"],
    file: "logo/emarsys.svg",
  },
  facebook: {
    aliases: [],
    file: "logo/facebook.svg",
  },
  google: {
    aliases: [],
    file: "logo/google.svg",
  },
  linkedin: {
    aliases: [],
    file: "logo/linkedin.svg",
  },
  tiktok: {
    aliases: [],
    file: "logo/tiktok.svg",
  },
  twitter: {
    aliases: [],
    file: "logo/twitter.svg",
  },
};
